//
//

import { mapGetters, mapMutations } from "vuex";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import variablesCard from "@/components/Diagrams/variables-card.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { APP_DATE_SLASH, APP_DATETIME_SLASH } from "@/assets/js/appConfig";

export default {
    name: "DataModelModal",
    components: {
        AQModal,
        FabricSearch,
        variablesCard,
        AQDropdown,
        AQInput,
        AQBadge,
        AQCard
    },
    props: {
        editDataModel: {
            type: Object,
            default() {
                return {};
            }
        },
        isInEditMode: { type: Boolean, default: false }
    },
    data() {
        return {
            dateTimeFormat: APP_DATETIME_SLASH,
            dateFormat: APP_DATE_SLASH,
            resetDateField: false,
            dateTime: false,
            iconType: "string",
            booleanSelectedOption: [],
            initialDataModel: {},
            selectedOption: [],
            dataModelFields: {},
            validatePattern: {},
            isDisabled: false,
            searchInputNotValid: false,
            statementInputNotValid: false,
            isInteger: false,
            fieldType: "",
            stringoptions: true,
            boolOption: false,
            intOption: false,
            statementInput: "",
            activeTab: "dataModel",
            customDataModelPlv: false,
            searchFilterValue: "",
            hasClose: true,
            hasCancel: false,
            addDataModelModal: true,
            tempUsers: [],
            tempRoles: [],
            selectedCompareOption: "EQUAL",
            titleModal: this.$t("liveView.filters.dataModel"),
            stringOptions: [
                {
                    value: "EQUAL",
                    label: this.$t("liveView.filters.dataModelOperators.equals")
                },
                {
                    value: "NOT_EQUAL",
                    label: this.$t(
                        "liveView.filters.dataModelOperators.notEquals"
                    )
                },
                {
                    value: "CONTAINS",
                    label: this.$t(
                        "liveView.filters.dataModelOperators.contains"
                    )
                }
            ],
            booleanOptions: [
                {
                    value: "true",
                    label: this.$t("liveView.filters.dataModelOperators.true")
                },
                {
                    value: "false",
                    label: this.$t("liveView.filters.dataModelOperators.false")
                }
            ],
            integerOptions: [
                {
                    value: "EQUAL",
                    label: this.$t("liveView.filters.dataModelOperators.equals")
                },
                {
                    value: "NOT_EQUAL",
                    label: this.$t(
                        "liveView.filters.dataModelOperators.notEquals"
                    )
                },
                {
                    value: "GREATER_THAN",
                    label: this.$t("liveView.filters.dataModelOperators.greater")
                },
                {
                    value: "GREATER_THAN_OR_EQUAL",
                    label: this.$t(
                        "liveView.filters.dataModelOperators.greaterOrEqual"
                    )
                },
                {
                    value: "LOWER_THAN",
                    label: this.$t("liveView.filters.dataModelOperators.less")
                },
                {
                    value: "LOWER_THAN_OR_EQUAL",
                    label: this.$t(
                        "liveView.filters.dataModelOperators.lessOrEqual"
                    )
                }
            ]
        };
    },
    computed: {
        ...mapGetters("admin", ["roleList", "userList", "getGroupsListApp"]),
        ...mapGetters("reports", ["filterObject", "nrOfFilteredResults"]),
        hasSave() {
            return {
                label: this.$t("liveView.filters.addBtn"),
                disabled: this.isDisabled
            };
        },
        setDateFormat() {
            let formatToReturn = "";
            if (this.iconType === "date") {
                formatToReturn = this.dateFormat;
            } else if (this.iconType === "datetime") {
                formatToReturn = this.dateTimeFormat;
            }
            return formatToReturn;
        },
        selectStringOptions() {
            return {
                options: this.stringOptions,
                defaultValue: this.selectedOption && this.selectedOption[0] ? this.selectedOption[0] : "EQUAL"
            };
        },
        selectIntegerOptions() {
            return {
                options: this.integerOptions,
                defaultValue: this.selectedOption && this.selectedOption[0] ? this.selectedOption[0] : "EQUAL"
            };
        },
        selectBooleanOptions() {
            return {
                options: this.booleanOptions,
                defaultValue: this.booleanSelectedOption && this.booleanSelectedOption[0] ? this.booleanSelectedOption[0] : "true"
            };
        }
    },
    created() {
        if (this.isInEditMode) {
            this.searchInputNotValid = false;
            this.searchFilterValue = this.editDataModel.fieldName;
            this.localSearchValue = this.editDataModel.fieldName;
            this.selectedOption.push(this.editDataModel.operator);
            this.statementInput = this.editDataModel.value;
            this.fieldType = this.editDataModel.fieldType;
            this.initialDataModel = { ...this.editDataModel };
            this.iconType = this.editDataModel.fieldType.toLowerCase();
            if (this.editDataModel.fieldType === "BOOLEAN") {
                this.boolOption = true;
                this.booleanSelectedOption.push(this.editDataModel.value);
                this.stringoptions = true;
            } else if (this.editDataModel.fieldType === "STRING") {
                this.stringoptions = true;
            } else if (
                this.editDataModel.fieldType === "DATE"
                || this.editDataModel.fieldType === "TIME"
                || this.editDataModel.fieldType === "DATETIME"
            ) {
                this.statementInput = this.editDataModel.statementInput;
                this.boolOption = false;
                this.stringoptions = false;
                this.intOption = true;
                this.dateTime = true;
                this.resetDateField = true;
            } else {
                this.stringoptions = false;
                this.intOption = true;
            }
        }
    },
    methods: {
        ...mapMutations("reports", [
            "setFilterObject",
            "setFiltredTasks",
            "setDataModelFilter"
        ]),
        actionsDlg($event) {
            if ($event === "primary") {
                this.dataModelFields.fieldName = this.searchFilterValue;
                this.dataModelFields.operator = this.editDataModel && this.editDataModel.operator ? this.editDataModel.operator : this.selectedCompareOption;
                this.dataModelFields.value = this.statementInput;
                this.dataModelFields.fieldType = this.fieldType === "INTEGER" ? "NUMBER" : this.fieldType;
                this.validateDataModelModal(
                    this.validatePattern,
                    this.dataModelFields.fieldType
                );
                if (
                    this.isInEditMode
                    && this.dataModelFields.fieldName
                    && this.dataModelFields.value
                ) {
                    this.$emit("makeTheCall", true);
                }
                if (!this.statementInputNotValid && !this.searchInputNotValid) {
                    this.searchInputNotValid = false;
                    this.statementInputNotValid = false;
                    this.addDataModelModal = false;
                    this.$emit("input", false);
                    this.$store.commit(
                        "reports/setDataModelFilter",
                        this.dataModelFields
                    );
                }
            } else if ($event === "close") {
                this.addDataModelModal = false;
                this.$emit("input", false);
                if (this.isInEditMode) {
                    this.$store.commit(
                        "reports/setDataModelFilter",
                        this.initialDataModel
                    );
                }
            }
        },
        valueSelected(data) {
            // eslint-disable-next-line vue/no-mutating-props
            this.editDataModel.operator = data[0].value;
            this.selectedCompareOption = data && data[0] && data[0].value ? data[0].value : "";
        },
        statementValueSelected(data) {
            this.statementInput = data && data[0] && data[0].value ? data[0].value : "";
        },
        // get data from the DataModelTree on selecting a property
        onFieldClicked(data) {
            this.statementInput = "";
            this.searchInputNotValid = false;
            this.isDisabled = false;
            this.customDataModelPlv = false;
            this.searchFilterValue = data.field.name;
            this.localSearchValue = data.field.name;
            this.fieldType = data.field.type.toUpperCase();
            if (data.field.type === "boolean") {
                this.iconType = data.field.type;
                this.intOption = false;
                this.boolOption = true;
                this.stringoptions = false;
                this.dateTime = false;
            } else if (data.field.type === "string") {
                this.iconType = data.field.type;
                this.dateTime = false;
                this.stringoptions = true;
                this.boolOption = false;
                this.intOption = false;
            } else if (
                data.field.type === "date"
                || data.field.type === "time"
                || data.field.type === "datetime"
            ) {
                this.resetDateField = false;
                this.iconType = data.field.type;
                this.boolOption = false;
                this.stringoptions = false;
                this.intOption = true;
                this.dateTime = true;
                setTimeout(() => {
                    this.resetDateField = true;
                }, 0);
            } else if (data.field.type === "integer") {
                this.iconType = "integer";
                this.dateTime = false;
                this.stringoptions = false;
                this.boolOption = false;
                this.intOption = true;
            } else if (data.field.type === "decimal") {
                this.iconType = "decimal";
                this.dateTime = false;
                this.stringoptions = false;
                this.boolOption = false;
                this.intOption = true;
            } else {
                this.iconType = "string";
                this.dateTime = false;
                this.stringoptions = false;
                this.boolOption = false;
                this.intOption = true;
            }
        },
        conditionIcon() {
            let conditionType;
            switch (this.iconType) {
                case "boolean":
                    conditionType = "BOOLEAN";
                    break;
                case "integer":
                case "number":
                    conditionType = "INTEGER";
                    break;
                case "decimal":
                    conditionType = "DECIMAL";
                    break;
                case "time":
                    conditionType = "TIME";
                    break;
                case "datetime":
                    conditionType = "DATETIME";
                    break;
                case "date":
                    conditionType = "DATE";
                    break;
                default:
                    conditionType = "TXT";
                    break;
            }
            return conditionType;
        },
        dataModelObject(data) {
            this.dataModelObj = data;
        },
        afterHide() {
            this.$emit("closed", this.saved);
        },
        validateDataModelModal(validatePattern, fieldType) {
            if (fieldType === "NUMBER") {
                this.validatePattern = /^-?\d*\d*$/;
            } else if (fieldType === "DECIMAL") {
                this.validatePattern = /^[-+]?(\d+\.?\d{0,9}|\.\d{1,9})$/;
            }
            if (
                this.searchFilterValue !== this.localSearchValue
                || (!this.statementInput && !this.searchFilterValue)
            ) {
                this.searchInputNotValid = true;
            } else {
                this.searchInputNotValid = false;
            }
            if (
                (!this.statementInput && !this.boolOption && !this.dateTime)
                || ((fieldType === "NUMBER" || fieldType === "DECIMAL")
                    && !this.validatePattern.test(this.statementInput))
            ) {
                this.statementInputNotValid = true;
            } else {
                this.statementInputNotValid = false;
            }
        },
        errorSearchLabel() {
            return this.searchInputNotValid
                ? this.$t("liveView.filters.validations.noProperty")
                : "";
        },
        errorStatementLabel() {
            return this.statementInputNotValid
                ? this.$t("liveView.filters.validations.noStatement")
                : "";
        },
        openDataModelCollaps() {
            this.customDataModelPlv = true;
        }
    }
};
